<template>
  <v-form v-model="valid" ref="DialogForm">
    <slotted-dialog :title="$t('servicesystem.common_objects.machine.transfer_work_title')"
      :externaltrigger="dialogtrigger" :externalCloseTrigger="closetrigger">

      <template v-slot:content>
        <v-container :key="'' + machineJob.Id + dialogtrigger">
          <v-row>
            <v-col>
              <h4 v-text="$t('servicesystem.common_objects.machine.transfer_work_from')" />
              <MachineSelect :value="machineJob.Machine" returnobject disabled>
              </MachineSelect>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0">
              <h4 v-text="$t('servicesystem.common_objects.machine.transfer_work_to')" />
              <MachineSelect v-model="newMachineId" :filter="optionFilter" externaledit disableAttach>
              </MachineSelect>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0">
              <v-card class="py-2 px-3" flat style="border: 1px solid var(--v-primary-base)">
                <v-row no-gutters>
                  <v-col cols="auto" class="d-flex align-center justify-center flex-column">
                    <v-icon size="20" color="primary">mdi-information</v-icon>
                    <b class="primary--text mb-0">{{ $t('servicesystem.common_objects.commonterms.info') }}</b>
                  </v-col>
                  <v-divider class="mx-3" vertical></v-divider>
                  <v-col cols="0">
                    <p class="mb-0 primary--text" v-html="$t('servicesystem.common_objects.machine.transfer_work_tip')">
                    </p>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </template>

      <template v-slot:buttons>
        <v-btn @click=" closetrigger++" color="primary" outlined
          v-text="$t('servicesystem.common_objects.commonterms.cancel')">
        </v-btn>
        <v-btn @click="valid ? save() : null" :disabled="!valid" :color="valid ? 'tertiary' : 'disabled'" :dark="valid">{{
          $t('servicesystem.common_objects.commonterms.save') }}</v-btn>
      </template>
    </slotted-dialog>
  </v-form>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import MachineSelect from "@/components/Inputs/EntityDropdowns/MachineSelect2.vue";
import SlottedDialog from "@/views/layouts/SlottedDialog.vue";

export default {
  name: "TransferMachineWorkDialog",
  props: {
    externaltrigger: Number,
    machineJob: Object,
    optionFilter: Object,
  },
  components: {
    SlottedDialog,
    MachineSelect,
  },
  mixins: [clientAPI],

  data() {
    return {
      dialogtrigger: 0,
      closetrigger: 0,
      newMachineId: 0,
      valid: false,
      loading: false,
    };
  },

  mounted() {
    this.newMachineId = undefined;
  },

  methods: {
    save() {
      this.loading = true;
      this.transferSubjobDetails(this.machineJob.Id, this.newMachineId)
        .then((response) => {
          response.changed = true;
          this.$emit("Update", response);
          this.$router.push({ query: { timestamp: this.getNowTime(this.oldTimeFormat) } });
          this.closetrigger++;
        })
        .catch(() => { })
        .finally(() => {
          this.loading = false;
        });
    },
  },

  computed: {},

  watch: {
    "machineJob.Id": function () {
      this.newMachineId = undefined;
    },

    externaltrigger: function () {
      this.dialogtrigger++;
      this.newMachineId = undefined;
      //console.log('machineJob', this.machineJob);
    },
  },
};
</script>